// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/nominativi/opzioni/condizioni-pagamento?societaId=${societaId}',
    requestBody: null,
    response: '{"success":"boolean","data":"CondizionePagamentoLite[]"}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/opzioni/codici-iva?societaId=${societaId}',
    requestBody: null,
    response: '{"success":"boolean","data":"CodiceIvaLite[]"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/email/:id',
    requestBody: '{"etichetta":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/email',
    requestBody: '{"etichetta":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"id":"number"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/email/:id',
    requestBody: null,
    response: '{"ok":"boolean"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/contatti/:id',
    requestBody: '{"nome":"string","cognome":"string","ruolo":"string","telefono":"string","cellulare":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"ok":"boolean"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/contatti',
    requestBody: '{"nome":"string","cognome":"string","ruolo":"string","telefono":"string","cellulare":"string","email":"string","principale":"boolean","ambito":"string"}',
    response: '{"id":"number"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/nominativi/:id/contatti/:id',
    requestBody: null,
    response: '{"ok":"boolean"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/nominativi/:id/fornitore',
    requestBody: '{"categoriaFornitore":"string","iban":"string","abi":"string","cab":"string","banca":"string","filialeBanca":"string","condizionePagamentoId":"number","codiceIvaDefaultId":"number","note":"string"}',
    response: '{"ok":"boolean"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
